// extracted by css-extract-rspack-plugin
export default {"cell-title":"SuOsHA","cellTitle":"SuOsHA","published-time":"Vg1K3V","publishedTime":"Vg1K3V","timestamp-and-flags":"MA1pro","timestampAndFlags":"MA1pro","flags":"qyfwz1"};